/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedBlurbReturns_item = {|
  +blurbReturnPolicy: ?{|
    +accept: ?any;
    +notifyDays: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbReturns_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "blurbReturnPolicy",
      "args": null,
      "concreteType": "ReturnPolicy",
      "name": "returnPolicy",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "accept",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "notifyDays",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
